import { Select } from "antd";
import { triggers_type } from "../constants/triggers";
import React, { useState } from "react";
import Webhook from "./Webhook";
import CronTrigger from "./CronTrigger";
import BaseRowAction from "./BaseRowAction";
import {
    updateTriggerConfigAutomation, updateTypeTriggerAutomation
} from "../../../../../hooks/automation";
import { connect } from "react-redux";
import BaseRowMultAction from "./BaseRowMultAction";

const Trigger = ({ trigger, onUpdateTriggerConfigAutomation, onUpdateTypeTriggerAutomation, automationBasicData }) => {

    const typeTrigger = trigger ? trigger.type : null

    const handleTriggerDataChange = async (config) => {
        await onUpdateTriggerConfigAutomation({ config })
    }

    const handleTriggerTypeChange = async (type) => {
        await onUpdateTypeTriggerAutomation({ type })
    }

    const handlerTypeTrigger = () => {
        switch (typeTrigger) {
            case "multiple_row_action":
                return <BaseRowMultAction trigger={trigger} onChange={handleTriggerDataChange} />
            case "row_created":
                return <BaseRowAction trigger={trigger} onChange={handleTriggerDataChange} />
            case "row_updated":
                return <BaseRowAction trigger={trigger} onChange={handleTriggerDataChange} />
            case "row_deleted":
                return <BaseRowAction trigger={trigger} onChange={handleTriggerDataChange} />
            case "webhook":
                return <Webhook trigger={trigger} automation={automationBasicData} onChange={handleTriggerDataChange} />
            case "cron_trigger":
                return <CronTrigger trigger={trigger} onChange={handleTriggerDataChange} />
        }
    }

    return (
        <div className="ae-section">
            <div className="ae-section__label">Configuração</div>
            <div className="ae-field">
                <label className="ae-label">Tipo de gatilho</label>
                <Select style={{ width: "100%" }}
                    placeholder="Selecione o tipo de gatilho"
                    onChange={(value) => handleTriggerTypeChange(value)}
                    defaultValue={typeTrigger}
                >
                    {triggers_type.map(trigger => (
                        <Select.Option key={trigger.type} value={trigger.type}>
                            {trigger.icon} {trigger.name}
                        </Select.Option>
                    ))}
                </Select>
            </div>
            {
                typeTrigger && handlerTypeTrigger()
            }
        </div>
    );
}

const mapStateToProps = ({ automation }) => ({
    trigger: automation.trigger,
    automationBasicData: automation.automation
});

const mapDispatchToProps = (dispatch) => {
    return {
        onUpdateTriggerConfigAutomation: ({
            config
        }) => dispatch(updateTriggerConfigAutomation({
            config
        })),
        onUpdateTypeTriggerAutomation: ({ type }) => dispatch(updateTypeTriggerAutomation({ type })),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Trigger);
